import MyFooter from './Footer';
export default MyFooter;